import Typography from '../Typography/Typography.js';
import Checkbox from '../../Forms/Checkbox/Checkbox.js';
import React__default, { memo, useState, useEffect } from 'react';
import styles from './Table.module.scss.js';
import TableRow from './components/TableRow/TableRow.js';
import classNames from 'classnames';
import cloneDeep from '../../../node_modules/lodash/cloneDeep.js';

const generateUID = () => {
    const UT = new Date().valueOf();
    const Salt = Math.floor(Math.random() * 100000);
    const UID = `${UT}${Salt}`;
    return UID;
};
const deepCopy = (arr) => {
    //return JSON.parse(JSON.stringify(arr));
    return cloneDeep(arr);
};
const Table = ({ headers, width = '100%', rows, typographyTag = 'textdefault', isSelectable = false, hasSelectAll = false, indentation = 10, stickyHeader = false, debug = false, selectableText = true, headerBackgroundColor = '#FFFFFF', hasFilter = false, filterQuery = '', virtualized = false, noResultsMessage = 'No results', hoverRow = true, pointerCursor = false, hasBottomBorder = false, headerVerticalAlign = 'middle', onRowClick, onRowDoubleClick, onRowMouseOver, onRowMouseOut, onRowRightClick, }) => {
    console.log('Table component rendered');
    const alignments = headers.map(header => header.align); // Extract the alignments
    const keys = headers
        .map(header => header.columnKey)
        .filter((columnKey) => typeof columnKey === 'string');
    const [allChecked, setAllChecked] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]); // New state to track selected rows
    const [filteredRows, setFilteredRows] = useState(rows);
    useEffect(() => {
        if (hasFilter) {
            if (filterQuery.length > 0) {
                setFilteredRows(filterObjects(rows, filterQuery));
            }
            else {
                setFilteredRows(rows);
            }
        }
        else {
            setFilteredRows(rows);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasFilter, filterQuery, rows]);
    const handleCheckAll = () => {
        const newAllChecked = !allChecked;
        setAllChecked(newAllChecked);
        // If the new allChecked state is true, set all row ids to selectedRows, else set it to an empty array
        setSelectedRows(newAllChecked ? filteredRows.map(row => row.id) : []);
    };
    const handleRowCheck = (id, checked) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setSelectedRows((prevSelectedRows) => {
            if (checked) {
                // If the row is checked, add its id to the selectedRows array
                return [...prevSelectedRows, id];
            }
            else {
                // If the row is unchecked, remove its id from the selectedRows array
                return prevSelectedRows.filter(rowId => rowId !== id);
            }
        });
    };
    const idIsChecked = (id) => {
        return selectedRows.includes(id);
    };
    /* const updateNodes = (
      nodes: TableRowData[],
      searchTerm: string,
      parentMatch: boolean = false,
      parentTree: string[] = [],
      allNodes: TableRowData[],
    ): TableRowData[] => {
      for (const node of nodes) {
         // const hasMatch = Object.values(node.data).some(value =>
        //  (value as string).toLowerCase().includes(searchTerm.toLowerCase()),
       // );
        const hasMatch = Object.values(node.data).some(value => {
          if (typeof value === 'string') {
            return value.toLowerCase().includes(searchTerm.toLowerCase());
          } else if (typeof value === 'number') {
            return value
              .toString()
              .toLowerCase()
              .includes(searchTerm.toLowerCase());
          } else if (React.isValidElement(value)) {
            if (value.props.searchText) {
              return value.props.searchText
                .toLowerCase()
                .includes(searchTerm.toLowerCase());
            }
  
            return false;
          }
          return false; // Return false for other types
        });
  
        if (hasMatch) {
          node.isHidden = false;
  
          handleUpdate(parentTree);
          // if (node.isExpanded !== undefined) {
           // node.isExpanded = true;
          //}
        } else {
          if (parentMatch === false) node.isHidden = true;
          else node.isHidden = false;
  
          if (node.isExpanded !== undefined) {
            node.isExpanded = false;
          }
        }
  
        if (node.children) {
          parentTree.push(node.id);
          updateNodes(
            node.children,
            searchTerm,
            parentMatch === true ? true : hasMatch,
            parentTree,
            nodes,
          );
        }
        // if (node.children && node.children.length > 0) {
        //  node.children.forEach(child => (child.isHidden = true));
        //}
      }
      return nodes;
    }; */
    function matchFound(node, searchText) {
        const hasMatch = Object.values(node.data).some(value => {
            if (typeof value === 'string') {
                return value.toLowerCase().includes(searchText.toLowerCase());
            }
            else if (typeof value === 'number') {
                return value
                    .toString()
                    .toLowerCase()
                    .includes(searchText.toLowerCase());
            }
            else if (React__default.isValidElement(value)) {
                if (value.props.searchText) {
                    return value.props.searchText
                        .toLowerCase()
                        .includes(searchText.toLowerCase());
                }
                return false;
            }
            return false; // Return false for other types
        });
        return hasMatch;
    }
    function dfs(node, searchText) {
        if (matchFound(node, searchText)) {
            if (searchText) {
                node.isHidden = false;
                node.isExpanded = false;
                // node.is_match = true; // Set is_match=true for matching nodes
            }
            return { match: true, node: node };
        }
        let anyChildMatch = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let matchingChildNode = null;
        if (Array.isArray(node.children)) {
            for (const child of node.children) {
                const childResult = dfs(child, searchText);
                if (childResult.match) {
                    matchingChildNode = childResult.node;
                    if (searchText) {
                        node.isHidden = false;
                        node.isExpanded = true;
                    }
                    anyChildMatch = true;
                }
            }
        }
        // Set is_visible and is_clicked for all the ancestors of the matched node
        if (matchingChildNode) ;
        else {
            // Reset is_visible and is_clicked for non-matching nodes
            if (searchText) {
                node.isHidden = true;
                node.isExpanded = false;
            }
        }
        return { match: anyChildMatch, node };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function filterObjects(arr, searchText) {
        /* if (searchText.length < 1) {
          console.log(searchText, "We are here");
          return staticRowsArray;
          console.log(props.stateObj);
        } */
        const NewArray = deepCopy(arr);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = [];
        for (const node of NewArray) {
            if (dfs(node, searchText)) {
                result.push(node);
            }
        }
        return result;
    }
    /*   function handleUpdate(ids: string[]) {
      const updatedData = updateIsHidden(ids, filteredRows);
      setFilteredRows(updatedData);
    } */
    /* useEffect(() => {
      if (hasFilter) {
        if (filterQuery.length > 0) {
          setFilteredRows(filterObjects(deepCopy(rows), filterQuery));
        }
      }
    }, [filterQuery]);  */
    return (React__default.createElement(React__default.Fragment, null,
        debug && JSON.stringify(selectedRows),
        React__default.createElement("table", { width: width, className: classNames(styles.Table, !selectableText && 'noselect', !hasBottomBorder && styles.HideBottomBorder) },
            React__default.createElement("thead", { className: stickyHeader ? styles.StickyHeader : undefined, style: { backgroundColor: headerBackgroundColor } },
                React__default.createElement("tr", { className: styles.Header },
                    isSelectable ? (React__default.createElement("th", { style: {
                            width: 20,
                            verticalAlign: headerVerticalAlign,
                        } }, hasSelectAll && (React__default.createElement(Checkbox, { id: "SelectAll", onChange: handleCheckAll, isChecked: filteredRows.length === selectedRows.length })))) : null,
                    headers.map((header, idx) => (React__default.createElement("th", { key: `${idx}_${generateUID()}`, style: {
                            width: header.columnWidth,
                            textAlign: alignments[idx],
                            verticalAlign: headerVerticalAlign,
                        } },
                        React__default.createElement(Typography, { tag: typographyTag },
                            React__default.createElement("b", null, header.title))))))),
            React__default.createElement("tbody", null, filteredRows.length === 0 ? (React__default.createElement("tr", { className: styles.empty },
                React__default.createElement("td", { colSpan: headers.length + 1, align: "center" },
                    React__default.createElement("div", { style: { padding: 30 } }, noResultsMessage)))) : (filteredRows.map(row => (React__default.createElement(TableRow, { key: `${row.id}_${generateUID()}`, alignments: alignments, keys: keys, row: row, indentation: indentation, typographyTag: typographyTag, isSelectable: isSelectable, virtualized: virtualized, hoverRow: hoverRow, pointerCursor: pointerCursor, isChecked: selectedRows.includes(row.id), onRowClick: onRowClick, onRowRightClick: onRowRightClick, onRowDoubleClick: onRowDoubleClick, onRowMouseOver: onRowMouseOver, onRowMouseOut: onRowMouseOut, onRowCheck: handleRowCheck, onCheckExists: idIsChecked }))))))));
};
var Table$1 = memo(Table);

export { Table$1 as default };
//# sourceMappingURL=Table.js.map
